import React, { createContext, useContext, useState, ReactNode } from "react";

interface Filters {
  sortField: string;
  sortOrder: string;
  pageNumber: number;
  pageSize: number;
  search: string;
  program: string; // 'all' or specific program
  orgUnitId: string;
  groupLabelId: string;
  status: string[];
  notEnrolled: boolean;

  assignedPrograms: string[];
  assignedOrgUnits: string[];
}

interface ClientsFiltersContextType {
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  persistFilters: boolean;
  setPersistFilters: React.Dispatch<React.SetStateAction<boolean>>;
}

const defaultFilters: Filters = {
  sortField: "fullName",
  sortOrder: "asc",
  pageNumber: 0,
  pageSize: 10,
  search: "",
  program: "all",
  orgUnitId: "",
  groupLabelId: "",
  status: ["Active", "Completed"],
  notEnrolled: false,

  assignedPrograms: [],
  assignedOrgUnits: [],
};

const ClientsFiltersContext = createContext<
  ClientsFiltersContextType | undefined
>(undefined);

export const ClientsFiltersProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [filters, setFilters] = useState<Filters>(defaultFilters);
  const [persistFilters, setPersistFilters] = useState<boolean>(false);

  return (
    <ClientsFiltersContext.Provider
      value={{ filters, setFilters, persistFilters, setPersistFilters }}
    >
      {children}
    </ClientsFiltersContext.Provider>
  );
};

export const useClientFilters = () => {
  const context = useContext(ClientsFiltersContext);
  if (!context) {
    throw new Error(
      "useClientFilters must be used within a ClientsFiltersContext",
    );
  }
  return context;
};
